class DeployerProgressBar extends HTMLElement {
  constructor() {
    super();
    this.currencyCode = this.dataset.currencyCode;
  }

  connectedCallback() {
    document.addEventListener('deployer:cart-update', (event) => {
      this.update(event.detail.data);
    });
  }
  /**
   *
   * @deprecated use the deployer:cart-update event instead to get the cart data
   */
  async getCart() {
    return fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }
  updateProgressBarWidth(data) {
    const newWidth = (data.total_price / this.getAmountValue(data.total_price)) * 100;
    this.querySelector('.free-item-progress--inner').style.width = `${newWidth}%`;
  }
  updateProgressTextDisplay(data) {
    const targetValue = parseFloat(this.getAttribute('amount'));
    const secondStepValue = parseFloat(this.getAttribute('amount-second-step'));

    let texts = {
      firstStepNotYet: '.free-item-progress-text_not_yet',
      firstStepSuccess: '.free-item-progress-text_succes',
      secondStepNotYet: '.free-item-progress-text_not_yet.second-step',
      secondStepSuccess: '.free-item-progress-text_succes.second-step',
    };

    for (const text in texts) {
      this.hideElement(texts[text]);
    }

    if (isNaN(targetValue)) {
      console.log('Error parsing targetValue');
      return;
    }

    if (data.total_price < targetValue) {
      this.showElement(texts.firstStepNotYet);
    } else if (data.total_price >= targetValue && (isNaN(secondStepValue) || data.total_price < secondStepValue)) {
      if (this.dataset.secondStep === 'true' && !isNaN(secondStepValue)) {
        this.showElement(texts.secondStepNotYet);
      } else {
        this.showElement(texts.firstStepSuccess);
      }
    } else if (!isNaN(secondStepValue) && data.total_price >= secondStepValue) {
      if (this.dataset.secondStep === 'true') {
        this.showElement(texts.secondStepSuccess);
      } else {
        this.showElement(texts.firstStepSuccess);
      }
    }
  }
  showElement(selector) {
    const element = this.querySelector(selector);
    if (element) {
      element.style.display = 'block';
    }
  }
  hideElement(selector) {
    const element = this.querySelector(selector);
    if (element) {
      element.style.display = 'none';
    }
  }
  setRemainingAmount(data) {
    const montantRestant = this.querySelectorAll('.free-item-progress-text span');
    if (montantRestant.length > 0) {
      montantRestant.forEach((element) => {
        element.innerText = this.formatPrice((this.getAmountValue(data.total_price) - data.total_price) / 100);
      });
    }
  }

  formatPrice(price) {
    switch (this.currencyCode) {
      case 'GBP':
        return '£' + price.toFixed(2).replace('.', ',');
        break;
      case 'USD':
        return '$' + price.toFixed(2).replace('.', ',');
        break;
      case 'EUR':
        return price.toFixed(2).replace('.', ',') + ' €';
        break;
      default:
        return price.toFixed(2).replace('.', ',') + ' €';
        break;
    }
  }

  getAmountValue(cartTotalPrice) {
    const amount = this.getAttribute('amount');
    const amountSecondStep = this.getAttribute('amount-second-step');

    if (amountSecondStep && cartTotalPrice >= parseFloat(amount)) {
      return parseFloat(this.querySelector('#mmCartProgressBarValue').value);
    } else {
      return parseFloat(amount);
    }
  }
  update(data) {
    if (this.querySelector('.free-item-progress--inner')) {
      this.updateProgressBarWidth(data);
      this.updateProgressTextDisplay(data);
      this.setRemainingAmount(data);
      updateCartCount(data.item_count != null ? data.item_count : 0);
    }
  }
  disconnetedCallback() {
    document.removeEventListener('deployer:cart-update', (event) => {
      this.update(event.detail.data);
    });
  }
}

window.customElements.define('deployer-progress-bar', DeployerProgressBar);

class DeliveryEstimation extends HTMLElement {
  constructor() {
    super();

    this.deliverySelectors = {
      container: '.delivery-estimation__container',
      delayContainer: '.delivery-estimation__delay-container',
      minimumDelay: '#datemin',
      maximumDelay: '#datemax',
      countdown: '#countdown',
    };

    // this.deliveryContainer = document.querySelector(deliverySelectors.container);
    this.deliveryDelayContainer = this.querySelector(this.deliverySelectors.delayContainer);
    this.deliveryMinimumDelay = this.querySelector(this.deliverySelectors.minimumDelay);
    this.deliveryMaximumDelay = this.querySelector(this.deliverySelectors.maximumDelay);
    this.countdown = this.querySelector(this.deliverySelectors.countdown);

    this.translation = JSON.parse(this.querySelector('[type="application/json"]').textContent);

    this.stock = {
      available: this.translation.stock_available,
      low: this.translation.stock_low,
    };

    this.date_format = this.translation.date_format;

    this.CSSClass = {
      available: 'stock-indic--available',
      low: 'stock-indic--low',
      out: 'stock-indic--out',
    };

    this.variantElms = document.querySelectorAll('.product-variant');
    this.currentVariantId = this.querySelector('.stock-disp-cont').dataset.currentVariantId;
  }

  connectedCallback() {
    this.init();
    this.listenEvents();
  }

  listenEvents() {
    document.addEventListener('variant:change', (event) => {
      this.currentVariantId = event.detail.variant.id;
      this.init();
    });
  }

  init() {
    this.variantsObj = [];

    this.variantElms.forEach((variantElm) => {
      this.variantsObj.push({
        id: variantElm.dataset.variantId,
        inventory_qty: variantElm.dataset.variantInventoryQty,
      });
    });

    const varIndex = this.variantsObj.findIndex((o) => parseInt(o.id) === parseInt(this.currentVariantId));
    const varQuantity = parseInt(this.variantsObj[varIndex].inventory_qty);
    const stockDisp = document.querySelector('.stock-disp');
    const stockIndic = document.querySelector('.stock-indic');

    if (stockIndic.classList.contains(this.CSSClass.low)) {
      stockIndic.classList.remove(this.CSSClass.low);
    }
    if (stockIndic.classList.contains(this.CSSClass.out)) {
      stockIndic.classList.remove(this.CSSClass.out);
    }
    if (stockIndic.classList.contains(this.CSSClass.available)) {
      stockIndic.classList.remove(this.CSSClass.available);
    }

    if (varQuantity >= 20) {
      stockDisp.innerHTML = this.translation.available;
      stockIndic.classList.add(this.CSSClass.available);
    } else if (varQuantity < 20 && varQuantity > 0) {
      stockDisp.innerHTML = `${this.translation.low_before} ${varQuantity} ${this.translation.low_after}`;
      stockIndic.classList.add(this.CSSClass.low);
    } else if (varQuantity <= 0) {
      stockDisp.innerHTML = `${this.translation.unavailable}`;
      stockIndic.classList.add(this.CSSClass.out);
    }

    this.updateDeliveryDelay();

    if (this.countdown) {
      this.startCountdown();
    }
  }

  updateDeliveryDelay() {
    let today = new Date();
    let datesDelai;

    if (this.deliveryDelayContainer.dataset.max === '0') {
      datesDelai = this.getDatesDelai(today, parseInt(this.deliveryDelayContainer.dataset.min));
    } else {
      datesDelai = this.getDatesDelai(
        today,
        parseInt(this.deliveryDelayContainer.dataset.min),
        parseInt(this.deliveryDelayContainer.dataset.max),
      );
    }

    this.deliveryMinimumDelay.innerHTML = this.dateFrenchFormat(datesDelai['dmin']);

    if (this.deliveryDelayContainer.dataset.max !== '0') {
      this.deliveryMaximumDelay.innerHTML = this.dateFrenchFormat(datesDelai['dmax']);
    }
  }

  dateFrenchFormat(dateAConvertir) {
    var jours = [
      window.translations.sunday,
      window.translations.monday,
      window.translations.tuesday,
      window.translations.wednesday,
      window.translations.thursday,
      window.translations.friday,
      window.translations.saturday,
      window.translations.sunday,
    ];
    var mois = [
      window.translations.january,
      window.translations.february,
      window.translations.march,
      window.translations.april,
      window.translations.may,
      window.translations.june,
      window.translations.july,
      window.translations.august,
      window.translations.september,
      window.translations.october,
      window.translations.november,
      window.translations.december,
    ];

    //TODO: mettre à jour le dmax par rapport au dmin quand le dmax est reporté au lundi suivant (cause week-end)

    var date = new Date(dateAConvertir);
    var day = date.getDate();
    // Ajuste la date pour les week-ends
    if (date.getDay() === 0) {
      // Dimanche
      // Ajoute 1 jour
      day = date.setDate(date.getDate() + 1);
    } else if (date.getDay() === 6) {
      // Samedi
      //
      day = date.setDate(date.getDate() + 2);
    }

    if (this.date_format === 'lettres') {
      var jourIndex = date.getDay();
      var message = jours[jourIndex] + ' ';
      message += day + ' ';
      message += mois[date.getMonth()] + ' ';
    } else {
      // Assure-toi que le mois est correctement affiché (les mois commencent à 0)
      var message = date.getDate() + '/';
      message += date.getMonth() + 1 + '/';
      message += date.getFullYear();
    }
    return message;
  }

  getDatesDelai(date1, delaiMin, delaiMax) {
    var result = new Array();
    var nbMin = typeof delaiMin != 'undefined' && delaiMin != null ? delaiMin : 2;
    var nbMax = typeof delaiMax != 'undefined' && delaiMax != null ? delaiMax : 2;
    var D = new Date(date1);

    if (this.checkIfIsValidDate(date1)) {
      result['dmin'] = D.setDate(D.getDate() + nbMin);
      nbMax ? (result['dmax'] = D.setDate(D.getDate() + nbMax)) : null;
    } else {
      result = null;
    }
    return result;
  }

  getDatesDelai(date1, delaiMin, delaiMax = delaiMin) {
    var result = {};
    var startDate = new Date(date1);
    startDate = this.adjustDateForWeekend(startDate);
    var minEndDate = new Date(startDate);
    // Calcule la date de fin minimale en ajoutant des jours ouvrables
    minEndDate = this.addBusinessDays(minEndDate, delaiMin);

    var maxEndDate = new Date(minEndDate);
    // Part de minEndDate pour calculer la date de fin maximale, en ajoutant le delta des jours ouvrables
    // Note: Le delta est calculé comme la différence entre delaiMax et delaiMin
    maxEndDate = this.addBusinessDays(maxEndDate, delaiMax);

    result['dmin'] = startDate.getTime() !== minEndDate.getTime() ? minEndDate : startDate;
    result['dmax'] = maxEndDate;

    return result;
  }

  addBusinessDays(startDate, numberOfBusinessDays) {
    var date = new Date(startDate.getTime());
    while (numberOfBusinessDays > 0) {
      date.setDate(date.getDate() + 1);
      // Diminue le nombre de jours uniquement pour les jours de semaine
      if (date.getDay() !== 0 && date.getDay() !== 6) {
        numberOfBusinessDays--;
      }
    }
    return date;
  }

  adjustDateForWeekend(date) {
    var adjustedDate = new Date(date.getTime());
    while (adjustedDate.getDay() === 0 || adjustedDate.getDay() === 6) {
      // 0: Sunday, 6: Saturday
      adjustedDate.setDate(adjustedDate.getDate() + (adjustedDate.getDay() === 0 ? 1 : 2));
    }
    return adjustedDate;
  }

  checkIfIsValidDate(d) {
    return Object.prototype.toString.call(d) === '[object Date]' && !isNaN(d.getTime()) ? true : false;
  }

  startCountdown() {
    const targetTime = this.getTargetTimeInFrance();
    const currentTime = this.getCurrentTimeInFrance();
    const timeRemaining = this.getTimeDifferenceInMs(targetTime, currentTime);

    this.countdown.innerHTML = this.formatDuration(timeRemaining);
  }

  getCurrentTimeInFrance() {
    const FRANCE_UTC_OFFSET = 120;
    const today = new Date();
    const localOffset = today.getTimezoneOffset();
    const franceTime = new Date(today.getTime() + (FRANCE_UTC_OFFSET + localOffset) * 60000);
    return franceTime;
  }

  getTargetTimeInFrance() {
    const now = this.getCurrentTimeInFrance();
    const noonToday = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 12, 0, 0);
    if (now < noonToday) {
      return noonToday;
    } else {
      const noonTomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 12, 0, 0);
      return noonTomorrow;
    }
  }

  getTimeDifferenceInMs(date1, date2) {
    return Math.abs(date1.getTime() - date2.getTime());
  }

  formatDuration(durationInMs) {
    const hours = Math.floor(durationInMs / (1000 * 60 * 60));
    const minutes = Math.floor((durationInMs % (1000 * 60 * 60)) / (1000 * 60));
    return `${hours} heures, ${minutes} minutes`;
  }
}

window.customElements.define('delivery-estimation', DeliveryEstimation);
